import React from 'react'
import { Route } from 'react-router-dom'
import { GroupList } from './content/group-list'
import { GroupAdd } from './content/group-add'
import { GroupEdit } from './content/group-edit'
import { GroupListUser } from './content/group-edit/group-list-user'
import { useApiFormGroup, useApiListGroup } from '../../../../api-new/state/content'
import { GroupListContent } from './content/group-edit/group-list-content'
import { RecycleList } from '../../../../shared/recycle/recycle-list'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../shared/hooks/location'
import { IconActivityLog } from '../../../../shared/icon/icon'
import { ActivityPage } from '../../../../shared/audit/activity/activity-page'

// The group's Activity tab (audit trail phase 5): what its current members
// did. The group's own changes are in its History.
export const GroupActivityRoute = () => {
  const { groupID } = useParamsInt()
  return (
    <BreadcrumbView Icon={IconActivityLog} text="ACTIVITY">
      <ActivityPage kind="group" id={groupID} />
    </BreadcrumbView>
  )
}

export const LayoutGroup = () => {
  return (
    <React.Fragment>
      <Route path="/org/group/list" component={GroupList} />
      <Route path="/org/group/list/add" component={GroupAdd} />
      <Route path="/org/group/list/edit/:groupID" component={GroupEdit} />
      <Route path="/org/group/list/edit/:groupID/content" component={GroupListContent} />
      <Route path="/org/group/list/edit/:groupID/user" component={GroupListUser} />

      <Route path="/org/group/list/edit/:groupID/activity">
        <GroupActivityRoute />
      </Route>

      <Route path="/org/group/list/recycle">
        <RecycleList useApiList={useApiListGroup} useApiForm={useApiFormGroup} field1="name" canEmpty />
      </Route>
    </React.Fragment>
  )
}
